import type { CSSProperties, ReactNode } from 'react';

interface C2CardProps {
  children?: ReactNode;
  pad?: number;
  color?: string;
  interactive?: boolean;
  className?: string;
  style?: CSSProperties;
}

export default function C2Card({
  children,
  pad = 32,
  color,
  interactive,
  className = '',
  style,
}: C2CardProps) {
  return (
    <div
      style={{
        background: color ?? 'var(--color-surface)',
        padding: pad,
        ...style,
      }}
      className={[
        'rounded-xl border border-hairline transition-[transform,box-shadow] duration-200',
        interactive ? 'cursor-pointer' : '',
        className,
      ].join(' ')}
    >
      {children}
    </div>
  );
}
